module.exports = {
  menu: {
    logo: "MIM Collaborative Platform",
  },
  other: "Other",
  all: "All",
  search_remind: "Please enter search content",
  search: "Search",
  add_project: "Add project",
  project_name: "Project name",
  project_type: "Project type",
  project_type_remind: "Please elects project type",
  project_contracting: "Project contracting",
  engineering_consulting: "Engineering consulting",
  engineering_design: "Engineering design",
  planning_time: "Planning time",
  start_date: "Start date",
  end_date: "End date",
  owner_name: "Owner name",
  address: "Address",
  progress: "Project progress",
  progress_remind: "Please enter an integer",
  introduction: "Introduction",
  upload_pictures: "Upload pictures",
  submit_upload: "Submit upload",
  upload: "Upload",
  file: "File",
  folder: "Folder",
  new_folder: "New folder",
  helpPart: "Help",
  user_center: "User center",
  submitFeedback: "Submit feedback",
  technologySupport: "Technology support",
  helpDocument: "Help document",
  instructionManual: "Instruction manual",
  registrationAndExit: "Registration and exit",
  // projectManagement: "Project management",
  projectManagement: "Project",
  fileManagement: "File management",
  drawingManagement: "Drawing management",
  MIMmodelManagement: "MIMmodel management",
  logout: "Logout",
  ok: "Ok",
  cancel: "Cancel",
  edit: "Edit",
  edit_node_remind: "Click edit to modify the content",
  delete: "Delete",
  key_nodes: "Key nodes",
  add_role: "Add Role",
  add_node: "Add node",
  role_manage: "Manage Role",
  batch_edit_member_role: "Batch edit member roles",
  hint: "Please input Role name",
  date: "Date",
  content: "Content",
  my_content: "My content",
  content_remind: "Please input the content",
  operation: "Actions",
  v_my_name: "My Name",
  v_email: "Verify email",
  email_code: "Email verification",
  v_email_remind: "Please enter the verification code",
  get_v_email: "Get vrification code",
  v_code: "The verification code will be sent to the verification mailbox",
  v_code_sent_to: "The captcha will be sent to",
  a1: "Duplicate item name, if you want to join this project, please select project first and apply",
  a2: "Apply to join the project with the same name",
  enter_info: "Confirmation information",
  creator1: "Creator",
  favs: "Favorite",
  establish: "Establish",
  drawing_size: "Paper size",
  creator1_time: "Creation time",
  enfi: "Technical support of China Mining Information Collaborative Innovation Center",
  enfi_add: "No. 12 Fuxing Road, Beijing",
  address2: "Add",
  contact_number: "Tel",
  qq: "QQ group",
  existProject: "Exist Project",
  website_record_number: "Website Record Number",
  website_record_number_date: "Beijing ICP:18055077",
  wechat_attention: "Wechat Attention",
  download: "Download",
  launch_mission: "Launch a mission",
  routerMeta: {
    // Survey: "Project Overview",
    Survey: "Overview",
    // FileControl: "File Manage",
    FileControl: "File",
    // DrawingManagement: "Drawing Manage",
    DrawingManagement: "Drawing",
    // MimModel: "MIM Model",
    MimModel: "Model",
    // ControlPage: "MIM Application",
    ControlPage: "Application",
    oxygenPage: "Oxygen Station",
    Case: "MIM Case",
    // MyApplication: "My Application",
    MyApplication: "MIM APP",
    Undeveloped: "Task Manage",
    // processManagement: "Process Management",
    processManagement: "Workflow",
    // ProjectSettings: "Project Setting",
    ProjectSettings: "Setting",
    ShareFile: "ShareFile",
    Home: "Home",
    MimCaseTwo: "MimCaseTwo",
    MimCaseThree: "MimCaseThree",
    MimCaseFive: "MimCaseFive",
    PreviewfileFormat: "PreviewfileFormat",
    ViewModel: "ViewModel",
    ViewDrawing: "ViewDrawing",
    MimCaseOne: "MimCaseOne",
    MimCaseFour: "MimCaseFour",
    MimCaseSix: "MimCaseSix",
    EnfiMeeting: "EnfiMeeting",
    // MonomerModel: "MonomerModel",
    MonomerModel: "Single Model",
    // IntegratedModel: "IntegratedModel",
    IntegratedModel: "Integrated Model",
    myProcess: "My Process",
    // upcomingTasks: "Upcoming Tasks",
    upcomingTasks: "Todo Task",
    doneTasks: "Done Tasks",
    EnfiNextcloud: "EnfiNextcloud",
    // deliver: "deliver",
    deliver: "Delivery",
    Upload: "Upload",
    deliveryBasis: "Delivery Basis",
    // projectObject: "project object",
    projectObject: "Object",
    // dataReport: "data report",
    dataReport: "Report",
    task: "TASK",
    formManagement: "Form",
    Definition: "Definition",
  },
  project_overview: "Project Overview",
  my_tasks1: "My to-do tasks",
  my_tasks2: "My completed tasks",
  my_tasks3: "My uploaded documents",
  my_tasks4: "My drawings",

  model_total: "Model total",
  drawing_total: "Drawing total",
  file_total: "File total",

  members_total: "Members total",
  project_members: "Project members",
  id: "Id",
  name: "Name",
  role: "Role",
  task_statistics: "Task statistics",
  new_creation1: "New creation",
  new_creation2: "Have in hand",
  new_creation3: "Completed",
  new_creation4: "Closed",
  new_creation5: "Network error",
  node_error: "Failed to query node information",
  survey_error: "Failed to query profile information",
  application_examples: "Application examples",
  my_examples: "My Application Examples",
  roam: "Automatic scene walkthrough",
  interactive: "Interactive MIM information query",
  simulation: "Schedule simulation",
  gis: "Loading GIS environment",
  YQS_geo_resource: "Geological resource model",
  Safety_management: "Safety management",
  Schedule: "Schedule",
  Shovel_loader: "Shovel loader",
  Shovel_btn1: "Spin",
  Shovel_btn2: "Shake",
  Shovel_btn3: "Jump and spin",
  Shovel_btn4: "Hover",
  YQS_trans_system: "Development transport system",
  show_project_info: "Display project information",
  hide_project_info: "Hide project information",
  ramp: "ramp",

  start_roam: "Start Roaming",
  pause_roam: "Pause Roaming",
  main_shaft: "Main shaft",
  auxiliary_shaft: "Auxiliary shaft",
  air_intake_shaft: "Air intake shaft",
  return_air_shaft: "Return air shaft",
  rail_trans_level: "Rail transportation level",
  pull_level: "Pull down level",
  ore_drawing_level: "Ore drawing level",
  close_twinkle: "Close twinkle",
  crushing_station: "Crushing station",
  visualization: "Design scheme visualization",
  device_m: "device management",
  RH_gis: "Loading Gis Map",
  monitoring: "Real time monitoring and early warning",
  inspection: "Visual inspection record",
  custom: "Custom development links",
  open: "Not yet open",
  subitem_m: "Subitem management",
  subitem: "Subitem",
  add_drawing: "Add drawing",
  b_delete: "Batch delete",
  a_delete: "Batch authorization",
  subitem_n: "Subitem name",
  drawing: "Drawing name",
  drawing_format: "Drawing format",
  authority: "Authority",
  version: "Version",
  updated_version: "Updated version",
  h_version: "Historical version",
  s_permissions: "Set permissions",
  rename: "Rename",
  s_rename: "Sheet rename",
  remarks: "Remarks",
  updated_drawing: "Updated drawing",
  drawings_documents: "Drawings documents",
  preview_list: "Preview list",
  add: "Add",
  role_or_person: "Role or person",
  jurisdiction: "Jurisdiction",
  preview: "preview",
  preview_people: "Add preview people",
  subordinate: "Subordinate",
  upload_drawings: "Upload drawings",
  select_from: "Select from document",
  file_name: "File name",
  select_upload: "Select and upload",
  add_subitem: "Add subitem",
  subitem_rename: "Subitem rename",
  google:
    "In order to improve the browsing experience of model drawings, we recommend that you use EDGE browser",
  download_address: "Download address",
  select_sub_item: "Please select the sub item of the drawing",
  select_major_item: "Please select a major",
  successfully_deleted: "Successfully deleted",
  authorization_successful: "Authorization successful",
  drawing_success: "Drawing renamed successfully",
  failed: "File acquisition failed",
  wait: "Uploading, please wait",
  please: "Please fill in the subitem first",
  cancel_deletion: "Cancel deletion",
  subitem_success: "Subkey renamed successfully",
  fill: "Please fill in the information",
  conversion_failed:
    "Conversion failed. Please delete the file and re format it before uploading",
  lightweight: "Lightweight processing in progress",
  please_upload: "Please upload the drawing file",
  model_success: "Model updated successfully",
  drawing_upload_success: "Drawings uploaded successfully",
  subitem_success2: "Subitem added successfully",
  format_allowed: "Model file format is not allowed, please upload again",
  v_deleted_success: "Version deleted successfully!",
  failed_drawing: "Failed to add drawing",
  deletion_canceled: "  Deletion canceled",
  all_file: "All documents",
  file_not_created: "File not created",
  favorites: "Favorites",
  shared: "Shared",
  recycle_bin: "Recycle bin",
  label: "Label",
  collection: "Collection",
  cancel_collection: "Cancel collection",
  share: "Share",
  copy_move: "Copy move",
  tagging: "Tagging",
  confirm_deletion: "Confirm deletion",
  file_size: "File size",
  creation_time: "Creation time",
  transformation: "Transformation",
  complete: "Complete",
  label_setting: "Label setting",
  delete_restore: "Delete / restore",
  not_subfolders: "Not more subfolders",
  copy: "Copy",
  move: "Move",
  copy_to: "Copy to",
  move_to: "Move to",
  move_to2: "Please enter a folder name",
  set_label: "Set label",
  please_2: "Please",
  please_3: "Choose a label color",
  please_4: "Label content",
  reduction: "Reduction",
  select_12: "Select sharing function",
  select_13: "Confirm selection",
  compare_1: "Select other version to compare",
  link_sharing: "Successful link sharing",
  copy_link: "Copy link",
  view_link: "View links",
  delete_link: "Delete links",
  file_name1: "Enter the file name",
  permission_list: "Permission list",
  modify1: "Modify",
  authorize: "Authorize",
  add_permission1: "Add permission",
  select_permissions2: "Select permissions",
  confirm_permissions3: "Confirm permissions",
  select_file2: "Select file",
  upload_to_server: "Upload to server",
  select_folder2: "Select folder",
  add_model2: "Add model",
  model_format: "Model format",
  model_size: "Model size",
  model_rename: "Model rename",
  model_name: "Model name",
  update_model2: "Update model",
  model_file2: "Model file",
  cover_image: "Cover image (optional)",
  share_model_links: "Share model links",
  model_link_created: "Model link created",
  model_link: "Model link",
  cancel_sharing: "Cancel sharing",
  close: "Close",
  my_role: "My role",
  project_manager1: "Project manager",
  add_members2: "Add members",
  serial_number: "Code",
  phone_number: "Phone Number",
  new_members3: "New members",
  select_role_type: "Select role type",
  design_manager: "Design manager",
  applications: "Application Manage",
  subItem_require: "Sub Item is required",
  subItem_name: "SubItem Name",
  project_management: "Project Space",
  model_n: "Model Name",
  modelFormat: "Model Format",
  select_remind: "Please select models",
  BelongSub: "Sub Item",
  app_name: "Application Name",
  status: "status",
  project_manager: "Project manager",
  progress_engineer: "Progress engineer",
  professional_director: "Professional director",
  main_designer: "Main designer",
  owner: "Owner",
  editorial_members: "Editorial members",
  project_information1: "Project info",
  edit_node: "Edit node",
  save: "save",
  download_check_box: "Download check box",
  go_back: "Go back",
  go_back12: "Page construction in progress",
  enter_version_list: "Enter version list",
  return_drawing_list: "Return list",
  translation: "Translation",
  rotate: "Rotate",
  zoom_to_all: "Zoom to all",
  add_comments: "Add comments",
  box_selection: "Box selection",
  circular: "Circular",
  square: "Square",
  words: "Words",
  re_annotate: "Re annotate",
  comments: "Comments",
  comment: "Comment",
  comment_count: "Comment quantity",
  full_version: "Full version",
  all_creators: "All creators",
  annotation_export: "Export annotation to Word document",
  i_create: "I create",
  export: "Export",
  create_an_annotation121: "You did not create an annotation!",
  associated_files: "Associated files",
  associated_files12: "Add associated file",
  share_drawing_links: "Share drawing links",
  drawing_link_created: "Drawing link created",
  drawing_links: "Drawing link",
  share_drawings: "Share drawings",
  share_links: "Share links",
  share_QR_code: "share QR code",
  save_picture: "Save picture",
  comment_area: "Comment area",
  submit: "Submit",
  label_name: "Role Name",
  tips: "Tips",
  delete_the_comment: "Delete the comment ?",
  return_model_list: "Return list",
  share_model: "Share model",
  wq_long:
    "The file is being processed. The first preview will take a long time",
  case1_1: "Auto roaming",
  case1_2: "Pause auto walk",
  case1_3: "View vertical sand bin",
  case1_4: "View mixing device",
  case1_5: "View thickener",
  case2_1: "Display of reinforced support roadway",
  case2_2: "Hidden reinforced support roadway",
  case2_3: "Display emergency refuge chamber",
  case2_4: "Hidden emergency refuge chamber",
  case2_5: "Show ventilation effect",
  case2_6: "Hide ventilation effect",
  case3_1: "Show growth animation",
  case4_1: "Load map",
  case4_2: "Hide map",
  case4_3: "The map is translucent",
  case4_4: "Modify map type",

  case5_1: "Display transportation lifting scheme",
  case5_2: "Hidden transportation lifting scheme",
  case5_3: "Display ventilation system scheme",
  case5_4: "Hidden ventilation system scheme",
  case5_5: "Scheme of display filling system",
  case6_1: "see information",
  case6_2: "Accident warning",
  RH_gis_btn1: "Load map",
  RH_gis_radio1: "Sky map image map",
  RH_gis_radio2: "Sky map vector map",
  RH_gis_radio3: "Gaode image map",
  RH_gis_radio4: "Gaode road map",
  RH_gis_radio5: "Bing map",
  YQS_geo_btn1: "Show mine information",
  YQS_geo_btn2: "Mine cutting",
  YQS_geo_btn3: "Show section box",
  YQS_geo_btn4: "Reset",
  YQS_geo_title: "Grade",
  ModelExplosion: "ModelExplosion",
  ME_botton: "ModelExplosion",
  ME_botton_alert: "Please drag the right progress bar",
  tips123:
    "Drawing model format supporting lightweight browsing：dwg, dxf, dwf, dwxf, rvt, dgn, rvm, ifc, nwd, fbx, 3ds, obj, dae, osgb, osgbzip,zip",
  file_manage_tips:
    "The format of drawing model supporting lightweight browsing: DWG, DXF, DGN, RVM, IFC, FBX, 3ds, obj, DAE, DWF, dwxf; Office files supporting online collaborative editing: docx, pptx, xlsx, TXT, etc",
  place_create_comments: "Please input comments",
  tips_model_message: "You don't have a MIM model yet. Go and create one",
  please_model_name: "Please enter the model name",
  please_remark_info: "Please enter the remark information",
  version_info_require: "Version information cannot be empty",
  set_success: "Set successfully",
  storage_space_full: "The storage space is full",
  please_3d: "Please upload 3D model",
  please_images: "Please upload the image format!",
  model_rename_success: "The model was renamed successfully",
  please_model_file: "Please upload the model file!",
  model_add_success: "Model added successfully",
  model_add_faile: "Failed to add model",
  please_sub_name: "Please enter the subkey name",
  please_name: "Please enter a name",
  please_2d: "Please upload 2D drawings!",
  signIn: "signIn",
  model: "model",
  total: "total",
  my: "my",
  permissionSource: "source",
  select_wj_share: "Confirm sharing",
  select_wj_cancel: "Delete shared",
  model_drawing_repeat: "Duplicate uploaded file",
  NewIntegration: "NewIntegration",
  upload_cover_type: "uploadCoverType",
  picture: "picture",
  upload_project_model: "Upload project model",
  expiration_time: "expiration time",
  drawing_comparison: "drawing comparison",
  process_management: "Process management",
  directory_tree: "Directory tree",
  object_detail: "Object detail",
  no_data: "No data",
  object_warning: "Please select an object to see the params",
  loadMode: "Load mode",
  fail: "fail",
  new: "new",
  major_manage: "major manage",
  management: "management",
  major_name: "major name",
  add_major: "add major",
  rename_major: "rename major",
  major: "major",
  docManagement: "docManagement",
  relationManagement: "relationManagement",
  searchPage: "searchPage",
  application_setting: "application setting",
  decompression: "decompression",
  weChat_binding: "WeChat binding",
  clear_cache: "Clear cache",
  preview_sharing: "Preview sharing",
  problem_feedback: "Problem feedback",
  platform_Introduction: "Platform Introduction",
  linkage: "linkage",
};



// WEBPACK FOOTER //
// ./src/assets/lang/en.js